/*!
 * MIGRACION (2026-09-15): pestañas "Precio Regular" / "Oferta: 2do al 50%"
 * sobre un producto de UNA sola variante, combinado con el descuento
 * automático nativo de Shopify "Compra X, obtén Y" (Buy X Get Y).
 *
 * Se activa solo en productos con el tag "oferta-tabs" (los 21 productos
 * reales migrados). No toca ni interfiere con oferta-2x1.js, que deja de
 * tener efecto automáticamente en estos productos en cuanto se les quita
 * la variante "2 frascos" (su guarda `if (!singleVariant || !doubleVariant)
 * return;` hace que no haga nada).
 *
 * Diferencia clave frente al sistema de variantes: aquí solo existe UNA
 * variante real. El 50% de descuento en el segundo frasco lo aplica
 * Shopify mismo (discountAutomaticBxgyCreate), no un cambio de variante ni
 * un cálculo nuestro. Por eso la cantidad que se ve en pantalla SIEMPRE es
 * la cantidad real que se cobra, en cualquier botón de compra —incluido
 * "Comprar con Shop"— sin necesidad de ocultar ningún botón.
 */

(function () {
  const configEl = document.querySelector('script[data-oferta-tabs-config]');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  const media = Array.isArray(config.media) ? config.media : [];
  const regularPrice = Number(config.regularPrice);
  if (!media.length || !Number.isFinite(regularPrice)) return;

  const BRAND_GREEN = '#98b859';

  const MSG_QUALIFIES_MANUAL =
    '🎉 ¡Con 2 frascos obtienes la oferta! El precio especial se aplica automáticamente.';

  function injectStyles() {
    if (document.getElementById('oferta-tabs-styles')) return;
    const style = document.createElement('style');
    style.id = 'oferta-tabs-styles';
    style.textContent = `
      [data-oferta-tabs] { display: flex; gap: 8px; margin-bottom: 14px; flex-wrap: wrap; }
      .oferta-tab-btn {
        flex: 1 1 auto; min-width: 140px; padding: 10px 14px; border-radius: 6px;
        border: 2px solid ${BRAND_GREEN}; background: #fff; color: ${BRAND_GREEN};
        font-weight: 700; font-size: 13px; cursor: pointer; text-align: center;
        transition: background-color .15s ease, color .15s ease;
      }
      .oferta-tab-btn--active { background-color: ${BRAND_GREEN}; color: #ffffff; }
      [data-oferta-tabs-price] { display: none; }
      [data-oferta-tabs-price].is-visible {
        display: block; margin: 4px 0 14px; padding: 10px 12px; border-radius: 6px;
        background: #eaf7ec; color: #1e7c34; font-size: 15px; font-weight: 600;
      }
      [data-oferta-tabs-price] .oferta-tabs-price__strike {
        text-decoration: line-through; color: #8a8a8a; font-weight: 400; margin-left: 8px;
      }
      quantity-input.oferta-tabs-locked { opacity: .55; pointer-events: none; }
    `;
    document.head.appendChild(style);
  }

  function setImage(index) {
    const MAX_ATTEMPTS = 20;
    let attempts = 0;
    function tryClick() {
      attempts++;
      const carousel = document.querySelector('media-carousel');
      const ready = carousel && carousel.classList.contains('is-initialized');
      const btn = document.querySelector('[data-slide-number="' + index + '"]');
      if (btn && ready) {
        btn.click();
        return;
      }
      if (attempts < MAX_ATTEMPTS) {
        setTimeout(tryClick, 150);
      } else if (btn) {
        btn.click();
      }
    }
    tryClick();
  }

  function init() {
    const qtyEl = document.querySelector('quantity-input');
    if (!qtyEl) return;
    const qtyInput = qtyEl.querySelector('input[name="quantity"]');
    if (!qtyInput) return;
    const plusBtn = qtyEl.querySelector('button[plus]');
    const minusBtn = qtyEl.querySelector('button[minus]');

    document.querySelectorAll('.product-single__box__block--variant_picker').forEach((el) => {
      el.style.display = 'none';
    });

    const qtyBlock =
      qtyEl.closest('.product-single__box__block--quantity_selector') ||
      qtyEl.closest('.product-form__qty') ||
      qtyEl.parentElement;
    if (!qtyBlock || !qtyBlock.parentElement) return;

    injectStyles();

    const tabsWrap = document.createElement('div');
    tabsWrap.setAttribute('data-oferta-tabs', '');
    tabsWrap.innerHTML =
      '<button type="button" class="oferta-tab-btn" data-tab="regular">Precio Regular</button>' +
      '<button type="button" class="oferta-tab-btn" data-tab="oferta">Oferta: 2do al 50%</button>';
    qtyBlock.parentElement.insertBefore(tabsWrap, qtyBlock);

    const priceMsg = document.createElement('div');
    priceMsg.setAttribute('data-oferta-tabs-price', '');
    qtyBlock.insertAdjacentElement('afterend', priceMsg);

    let currentTab = 'oferta';

    function checkManualQtyOnRegular() {
      if (currentTab !== 'regular') return;
      const qtyNow = Number(qtyInput.value);
      if (qtyNow === 2) {
        priceMsg.innerHTML = MSG_QUALIFIES_MANUAL;
        priceMsg.classList.add('is-visible');
      } else {
        priceMsg.classList.remove('is-visible');
        priceMsg.innerHTML = '';
      }
    }
    qtyInput.addEventListener('change', checkManualQtyOnRegular);
    qtyEl.addEventListener('update', checkManualQtyOnRegular);

    function activate(tab) {
      currentTab = tab;
      const regularBtn = tabsWrap.querySelector('[data-tab="regular"]');
      const offerBtn = tabsWrap.querySelector('[data-tab="oferta"]');

      if (tab === 'oferta') {
        offerBtn.classList.add('oferta-tab-btn--active');
        regularBtn.classList.remove('oferta-tab-btn--active');

        qtyInput.value = 2;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (plusBtn) plusBtn.disabled = true;
        if (minusBtn) minusBtn.disabled = true;
        qtyEl.classList.add('oferta-tabs-locked');

        setImage(0);

        const offerTotal = (regularPrice * 1.5).toFixed(2);
        const compareTotal = (regularPrice * 2).toFixed(2);
        priceMsg.innerHTML =
          '🎉 Precio con oferta (2 frascos): <strong>$' +
          offerTotal +
          '</strong><span class="oferta-tabs-price__strike">$' +
          compareTotal +
          '</span>';
        priceMsg.classList.add('is-visible');
      } else {
        regularBtn.classList.add('oferta-tab-btn--active');
        offerBtn.classList.remove('oferta-tab-btn--active');

        if (plusBtn) plusBtn.disabled = false;
        if (minusBtn) minusBtn.disabled = false;
        qtyEl.classList.remove('oferta-tabs-locked');
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

        setImage(1);

        priceMsg.classList.remove('is-visible');
        priceMsg.innerHTML = '';
      }
    }

    tabsWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tab]');
      if (!btn) return;
      activate(btn.getAttribute('data-tab'));
    });

    activate('oferta');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
